import { SystemPrivilege } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { OrganizationsPage } from '@/pages/organizations/list';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/manage/organisations/')({
  component: OrganizationsPage,
  beforeLoad: () =>
    privilegeGuardRoute({ privileges: [SystemPrivilege.ViewOrganization] }),
});
